export default __webpack_public_path__ + "654126892da6ff58b74bd58a550def4b.png";